let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("cOIYm")]).then(() => parcelRequire('8K7FM'));